import { render, staticRenderFns } from "./TemplateChoiceValueAutoComplete.vue?vue&type=template&id=0bf8cea2&scoped=true&"
import script from "./TemplateChoiceValueAutoComplete.vue?vue&type=script&lang=ts&"
export * from "./TemplateChoiceValueAutoComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf8cea2",
  null
  
)

export default component.exports